//#region Imports and Global Definitions
import React, { useState, useEffect, useCallback, } from 'react';
import { StyleSheet, SafeAreaView, Platform, useWindowDimensions, ScrollView, Image, View, FlatList, Pressable, SectionList, TouchableOpacity } from 'react-native';
import { useTheme } from '@react-navigation/native';
import { createCommonStyles } from '../../../../styles/commonStyles';
import CustomLabel from '../../../../components/CustomLabel/CustomLabel';
import CustomInput from '../../../../components/CustomInput';
import CustomButton from '../../../../components/CustomButton';
import { useCompany } from '../../../../hooks/useCompany';
var _ = require('lodash');
import { useTranslation } from 'react-i18next';
import { Controller, useForm, useWatch } from 'react-hook-form';
import { useHRAdminEmployees } from '../../../../hooks/useHRAdminEmployees';
import { ActivityIndicator, Card } from 'react-native-paper';
import { DEFAULTPROFILE } from '../../../../img/DefaultProfile';
import CustomControlledCheckbox from '../../../../components/ControlledComponents/CustomControlledCheckbox';
import CustomControlledDropdown from '../../../../components/ControlledComponents/CustomControlledDropdown';
import { v4 as uuidv4 } from 'uuid';
import Swal from 'sweetalert2';
import { showMessage } from 'react-native-flash-message';
import { generateUniqueID } from '../../../../components/SurveyBuilderComponent/CreateSurvey/CreateSurveyFunctions';
//#endregion

const TabComponent = React.memo(({ height, colors, styles, loadingEmployees, employees, control, t,
    employeesOriginal, noDataFound,
    showSpecificEmployeesTab, includedEmployeesSectionList, setIncludedEmployeesSectionList,
    includedEmplsSectionList, getValues, setValues, addPersonToGroupedData
}) => {
    const [selectedView, setSelectedView] = useState(0);

    useEffect(() => {
        if (showSpecificEmployeesTab) {
            setSelectedView(3);
        }
        else setSelectedView(0);
    }, [showSpecificEmployeesTab])

    return (
        <View style={{ height: height * 0.5 }}>
            <View style={{ flexDirection: 'row', justifyContent: 'space-around', marginBottom: 20 }}>
                <View style={{ flex: 1 }}>
                    <TouchableOpacity
                        style={{
                            flex: 1,
                            backgroundColor: selectedView === 0 ? colors.background_approved : colors.background_gray,
                            alignItems: 'center',
                            justifyContent: 'center',
                            padding: 10,
                            borderRightWidth: 1,
                            borderRightColor: selectedView === 0 ? '#7FBFA8' : '#A9A9A9',
                        }}
                        onPress={() => setSelectedView(0)}
                        disabled={showSpecificEmployeesTab ? true : false}
                    >
                        <CustomLabel value={t('common:includedEmpls')} type="SUBTITLE" />
                    </TouchableOpacity>
                </View>
                <View style={{ flex: 1 }}>
                    <TouchableOpacity
                        style={{
                            flex: 1,
                            backgroundColor: selectedView === 1 ? colors.background_approved : colors.background_gray,
                            alignItems: 'center',
                            justifyContent: 'center',
                            padding: 10,
                            borderRightWidth: 1,
                            borderRightColor: selectedView === 1 ? '#7FBFA8' : '#A9A9A9',
                        }}
                        onPress={() => setSelectedView(1)}
                        disabled={showSpecificEmployeesTab ? true : false}
                    >
                        <CustomLabel value={t('common:summary')} type="SUBTITLE" />
                    </TouchableOpacity>
                </View>
                <View style={{ flex: 1 }}>
                    <TouchableOpacity
                        style={{
                            flex: 1,
                            backgroundColor: selectedView === 2 ? colors.background_approved : colors.background_gray,
                            alignItems: 'center',
                            justifyContent: 'center',
                            padding: 10,
                            borderRightWidth: 1,
                            borderRightColor: selectedView === 2 ? '#7FBFA8' : '#A9A9A9',
                        }}
                        onPress={() => setSelectedView(2)}
                        disabled={showSpecificEmployeesTab ? true : false}
                    >
                        <CustomLabel value={t('common:employeesExcluded')} type="SUBTITLE" />
                    </TouchableOpacity>
                </View>
                <View style={{ flex: 1 }}>
                    <TouchableOpacity
                        style={{
                            flex: 1,
                            backgroundColor: selectedView === 3 ? colors.background_approved : colors.background_gray,
                            alignItems: 'center',
                            justifyContent: 'center',
                            padding: 10,
                            borderRightWidth: 1,
                            borderRightColor: selectedView === 3 ? '#7FBFA8' : '#A9A9A9',
                        }}
                        onPress={() => setSelectedView(3)}
                        disabled={!showSpecificEmployeesTab ? true : false}
                    >
                        <CustomLabel value={t('common:includeSpecEmpls')} type="SUBTITLE" />
                    </TouchableOpacity>
                </View>
            </View>
            {selectedView === 0 && (
                <View style={{ flex: 1 }}>
                    <RenderEmployees
                        loadingEmployees={loadingEmployees}
                        styles={styles}
                        employees={employees}
                        control={control}
                        colors={colors}
                        isIncludeEmployeesOnlyView={true}
                        employeesOriginal={employeesOriginal}
                        noDataFound={noDataFound}
                        setIncludedEmployeesSectionList={setIncludedEmployeesSectionList}
                        includedEmployeesSectionList={includedEmployeesSectionList}
                        includedEmplsSectionList={includedEmplsSectionList}
                        getValues={getValues}
                        setValue={setValues}
                        addPersonToGroupedData={addPersonToGroupedData}
                        t={t}
                    />
                </View>
            )}
            {selectedView === 1 && (
                <ScrollView showsVerticalScrollIndicator={true}>
                    <RenderSummary
                        getValues={getValues}
                        styles={styles}
                        t={t}
                    />
                </ScrollView>
            )}
            {selectedView === 2 && (
                <View style={{ flex: 1 }}>
                    <RenderEmployees
                        loadingEmployees={loadingEmployees}
                        styles={styles}
                        employees={employees}
                        control={control}
                        colors={colors}
                        isIncludeEmployees={false}
                        noDataFound={noDataFound}
                        setIncludedEmployeesSectionList={setIncludedEmployeesSectionList}
                        includedEmployeesSectionList={includedEmployeesSectionList}
                        includedEmplsSectionList={includedEmplsSectionList}
                        // specEmplsFinal={specEmplAddedFinal}
                        getValues={getValues}
                        setValue={setValues}
                        addPersonToGroupedData={addPersonToGroupedData}
                        t={t}
                    />
                </View>
            )}
            {selectedView === 3 && (
                <View style={{ flex: 1 }}>
                    <RenderEmployees
                        loadingEmployees={loadingEmployees}
                        styles={styles}
                        employees={employees}
                        control={control}
                        colors={colors}
                        isIncludeEmployees={false}
                        noDataFound={noDataFound}
                        isIncludeSpecificEmployees={true}
                        setIncludedEmployeesSectionList={setIncludedEmployeesSectionList}
                        includedEmployeesSectionList={includedEmployeesSectionList}
                        includedEmplsSectionList={includedEmplsSectionList}
                        getValues={getValues}
                        setValue={setValues}
                        addPersonToGroupedData={addPersonToGroupedData}
                        t={t}
                    />
                </View>
            )}
        </View>
    );
});

const RenderEmployees = React.memo(({ loadingEmployees, styles, employees, control,
    colors, isIncludeEmployeesOnlyView, t, noDataFound, isIncludeSpecificEmployees = false,
    setIncludedEmployeesSectionList, includedEmployeesSectionList, includedEmplsSectionList,
    getValues, setValue, addPersonToGroupedData
}) => {

    let excludedEmployees = useWatch({ control, name: 'excludedEmployees' });
    let specificEmployeesAdded = useWatch({ control, name: 'specificEmployeesAdded' });

    const toggleEmployeeSelection = (employeeId, name) => {
        const currentSelectedEmployees = getValues(name);
        if (currentSelectedEmployees.includes(employeeId)) {
            setValue(name, currentSelectedEmployees.filter(id => id !== employeeId));
        } else {
            setValue(name, [...currentSelectedEmployees, employeeId]);
        }
    };

    return (
        <SafeAreaView style={[styles.cardEmployees, { flex: 1 }]}>
            {loadingEmployees ? (
                <SafeAreaView style={styles.loader}>
                    <ActivityIndicator animating={true} color={colors.blue} />
                </SafeAreaView>
            ) : (
                <SectionList
                    sections={isIncludeSpecificEmployees ? employees : includedEmplsSectionList ?? []}
                    keyExtractor={(item, index) => `${item.employeeID}-${index}`}
                    initialNumToRender={30}
                    contentContainerStyle={{
                        paddingHorizontal: 10,
                    }}
                    style={{ flex: 1 }}
                    renderItem={({ item }) => (
                        <SafeAreaView style={{ flex: 1 }}>
                            <Controller
                                control={control}
                                name={isIncludeSpecificEmployees ? "selectedEmployees" :
                                    !isIncludeEmployeesOnlyView ? "excludedEmployees" : "selectedEmployees"}
                                render={({ field: { onChange } }) => (
                                    <Pressable
                                        onPress={() => {
                                            if (!isIncludeSpecificEmployees && !isIncludeSpecificEmployees) {
                                                toggleEmployeeSelection(item.employeeID, 'excludedEmployees');
                                            }
                                            else if (isIncludeSpecificEmployees) {
                                                setIncludedEmployeesSectionList(addPersonToGroupedData(includedEmployeesSectionList, item))
                                                toggleEmployeeSelection(item.employeeID, 'specificEmployeesAdded');
                                            }
                                        }}
                                        style={() => {
                                            if (isIncludeEmployeesOnlyView) {
                                                return excludedEmployees?.includes(item.employeeID) ? styles.selectedItemRemove :
                                                    specificEmployeesAdded?.includes(item.employeeID) ? styles.selectedItem : null;
                                            } else if (!isIncludeSpecificEmployees) {
                                                return specificEmployeesAdded?.includes(item.employeeID) && !excludedEmployees?.includes(item.employeeID)
                                                    ? styles.selectedItem :
                                                    excludedEmployees?.includes(item.employeeID) ?
                                                        styles.selectedItemRemove : null;
                                            }
                                            else {
                                                return specificEmployeesAdded?.includes(item.employeeID) ? styles.selectedItem : null
                                            }
                                        }}
                                        disabled={isIncludeEmployeesOnlyView}
                                    >
                                        <SafeAreaView style={styles.employeeContainer}>
                                            <Image
                                                style={styles.employeePhotograph}
                                                source={{
                                                    uri: `data:image/png;base64,${item.photograph || DEFAULTPROFILE}`,
                                                }}
                                            />
                                            <CustomLabel value={item.name} type="IMAGE_TEXT" />
                                        </SafeAreaView>
                                    </Pressable>
                                )}
                            />
                        </SafeAreaView>
                    )}
                    renderSectionHeader={({ section: { title } }) => (
                        <CustomLabel value={title} type="MAJOR" />
                    )}
                    ListEmptyComponent={
                        (noDataFound &&
                            <SafeAreaView style={styles.loader}>
                                <CustomLabel
                                    value={t("common:noResultsFound")}
                                    type="ASSM"
                                />
                            </SafeAreaView>
                        )
                    }
                />
            )}
        </SafeAreaView>
    );
});

const RenderSummary = React.memo(({ styles, t, getValues }) => {
    const excludedLength = getValues('excludedEmployees')?.length ?? 0;
    const selectedEmployeesLength = getValues('specificEmployeesAdded')?.length ?? 0;
    const selectedCriteriaLength = getValues('includedEmployees')?.length;
    const total = selectedCriteriaLength + selectedEmployeesLength - excludedLength;
    return (
        <SafeAreaView style={[]}>
            <SafeAreaView style={[styles.row]}>
                <CustomLabel
                    value={`${t("common:emplsSelectedThroughCriteria")}`}
                    type='COMPANY'
                />
                <CustomLabel
                    value={selectedCriteriaLength}
                    type='COMPANY'
                />
            </SafeAreaView>
            <SafeAreaView style={[styles.row]}>
                <CustomLabel
                    value={`${t("common:employeesExcluded")}`}
                    type='COMPANY'
                />
                <CustomLabel
                    value={excludedLength}
                    type='COMPANY'
                />
            </SafeAreaView>
            <SafeAreaView style={[styles.row]}>
                <CustomLabel
                    value={`${t("common:specificEmplsAdded")}`}
                    type='COMPANY'
                />
                <CustomLabel
                    value={selectedEmployeesLength}
                    type='COMPANY'
                />
            </SafeAreaView>
            <SafeAreaView style={[styles.row]}>
                <CustomLabel
                    value={`${t("common:totalNumOfEmplsIncluded")}`}
                    type='COMPANY'
                />
                <CustomLabel
                    value={total}
                    type='COMPANY'
                />
            </SafeAreaView>
        </SafeAreaView>
    )
});

const HRAdminAuthorizationForm = (props) => {
    const { isTrnParticipants, setErrorMessage, selectedTraining, setRules, rules,
        removeFromChangesAfterSave, saveParticipantsData, deleteAllParticipants, onSubmit,
        AfterImport
    } = props
    //#region Const Definitions
    const { width, height } = useWindowDimensions();
    const isPlatformWeb = (Platform.OS === 'web' && width > 992 ? false : true);
    const { colors } = useTheme();
    const common = createCommonStyles(colors);
    const styles = makeStyles(colors, width, height, isPlatformWeb);
    const { getCompanies, } = useCompany();
    const { getLocations, getDepartments, getSeniorityLevels, getEmploymentTypes, getJobTitles, getEmployees, getEmplAuthRules, deleteEmplAuthRule } = useHRAdminEmployees();
    const [isLoading, setIsLoading] = useState(false);
    const [isCompaniesLoading, setIsCompaniesLoading] = useState(false);
    const [searchQuery, setSearchQuery] = useState('');
    const [employeesOriginal, setEmployeesOriginal] = useState([]);
    const { t } = useTranslation();
    const { control, handleSubmit, formState: { errors }, setValue, getValues } = useForm({
        defaultValues: {
            username: props.employee?.username,
            employeeId: props.employee.employeeID,
            company: null,
            location: null,
            dept: null,
            hcode: null,
            jobTitle: null,
            employmentContext: null,
            employees: null,
            includeInactive: false,
            includedEmployees: [],
            excludedEmployees: [],
            specificEmployeesAdded: []
        },
    });
    const [companies, setCompanies] = useState([]);
    const company = useWatch({ control, name: 'company' });
    const location = useWatch({ control, name: 'location' });
    const dept = useWatch({ control, name: 'dept' });
    const hcode = useWatch({ control, name: 'hcode' });
    const jobTitle = useWatch({ control, name: 'jobTitle' });
    const employmentContext = useWatch({ control, name: 'employmentContext' });
    const includeInactive = useWatch({ control, name: 'includeInactive' });
    const [loadingEmployees, setLoadingEmployees] = useState(false);
    const [locationOptions, setLocationOptions] = useState([]);
    const [departmentOptions, setDepartmentOptions] = useState([]);
    const [seniorityLevelOptions, setSeniorityLevelOptions] = useState([]);
    const [employmentTypeOptions, setEmploymentTypeOptions] = useState([]);
    const [jobTitleOptions, setJobTitleOptions] = useState([]);
    const [specEmplsAdded, setSpecEmplsAdded] = useState([]);
    const [noDataFound, setNoDataFound] = useState(false);
    const [showSpecificEmployeesTab, setShowSpecificEmployeesTab] = useState(false);
    const [includedEmployeesSectionListTemp, setIncludedEmployeesSectionListTemp] = useState([]);
    const [employees, setEmployees] = useState([]);
    const [includedEmployeesSectionList, setIncludedEmployeesSectionList] = useState([]);
    const [specEmplsFinal, setSpecEmplsFinal] = useState([]);
    //#endregion

    //#region useEffect
    useEffect(() => {
        fetchCompanies();
    }, [])

    useEffect(() => {
        if (searchQuery !== undefined) {
            const delayDebounceFn = setTimeout(() => {
                findEmployees(searchQuery);
            }, 500);
            return () => clearTimeout(delayDebounceFn);
        }
    }, [searchQuery]);

    useEffect(() => {
        fillDropdowns();
    }, [company])
    //#endregion

    //#region Helpers
    const findEmployees = (searchQuery = '') => {
        let employees = employeesOriginal.filter(item => item.name.toLowerCase().includes(searchQuery.toLowerCase()));
        setEmployees(groupDataByLetter(employees));
    }

    const fetchCompanies = () => {
        setIsCompaniesLoading(true);
        getCompanies().then((res) => {
            setCompanies(res)
            setIsCompaniesLoading(false);
        })
    }

    const fetchEmployees = (isSpecificEmployees = false) => {
        setLoadingEmployees(true);
        getEmployees([],
            location ? [location] : [],
            dept ? [dept] : [],
            hcode ? [hcode] : [],
            employmentContext ? [employmentContext] : [],
            jobTitle ? [jobTitle] : [],
            "", company, true, includeInactive)
            .then((data) => {
                if (data?.length === 0 || !data) {
                    setNoDataFound(true);
                    setEmployees([]);
                    setLoadingEmployees(false);
                    return;
                }
                let grouped = groupDataByLetter(data);
                setEmployees(grouped);
                setEmployeesOriginal(data);
                const toggleEmployeeSelection = (employeeId, name) => {
                    const currentSelectedEmployees = getValues(name);
                    if (currentSelectedEmployees.includes(employeeId)) {
                        setValue(name, currentSelectedEmployees.filter(id => id !== employeeId));
                    } else {
                        setValue(name, [...currentSelectedEmployees, employeeId]);
                    }
                };

                if (!isSpecificEmployees)
                    data.forEach(employee => {
                        toggleEmployeeSelection(employee.employeeID, 'includedEmployees')
                    });

                if (!isSpecificEmployees) {
                    let copySectionList = [...includedEmployeesSectionList];
                    let updatedSectionList = [];
                    data.forEach(newPerson => {
                        updatedSectionList = addPersonToGroupedData(copySectionList, newPerson);
                    });
                    setIncludedEmployeesSectionList([...updatedSectionList]);
                }
                setLoadingEmployees(false);
            })
            .catch((err) => {
                setEmployees([]);
                setLoadingEmployees(false);
                setNoDataFound(true);
            });
    }

    const groupDataByLetter = (data) => {
        const grouped = data.reduce((acc, item) => {
            const firstletter = item.name[0].toUpperCase();
            if (!acc[firstletter])
                acc[firstletter] = []
            acc[firstletter].push(item);
            return acc;
        }, []);

        return Object.keys(grouped)
            .sort()
            .map((letter) => ({
                title: letter,
                data: grouped[letter],
            }));
    };

    const fillDropdowns = async () => {
        let locationOptionsTemp = [];
        let departmentOptionsTemp = [];
        let seniorityLevelOptionsTemp = [];
        let employmentTypeOptionsTemp = [];
        let jobTitleOptionsTemp = [];
        try {
            if (company) {
                let companyObj = { code: company };
                setIsLoading(true);
                getLocations(companyObj).then((locations) => {
                    locations.forEach((obj) => {
                        locationOptionsTemp.push({ label: obj.description, value: obj.location });
                    });
                    setLocationOptions(locationOptionsTemp);
                    getDepartments(companyObj).then((departments) => {
                        departments.forEach((obj) => {
                            departmentOptionsTemp.push({ label: obj.description, value: obj.dept });
                        });
                        setDepartmentOptions(departmentOptionsTemp);
                        getSeniorityLevels(companyObj).then((seniorityLevels) => {
                            seniorityLevels.forEach((obj) => {
                                seniorityLevelOptionsTemp.push({ label: obj.description, value: obj.hcode });
                            });
                            setSeniorityLevelOptions(seniorityLevelOptionsTemp);
                            getEmploymentTypes(companyObj).then((employmentTypes) => {
                                employmentTypes.forEach((obj) => {
                                    employmentTypeOptionsTemp.push({ label: obj.description, value: obj.etype });
                                });
                                setEmploymentTypeOptions(employmentTypeOptionsTemp);
                                getJobTitles(companyObj).then((jobTitles) => {
                                    jobTitles.forEach((obj) => {
                                        jobTitleOptionsTemp.push({ label: obj.description, value: obj.jobtitle });
                                    });
                                    setJobTitleOptions(jobTitleOptionsTemp);
                                    setIsLoading(false);
                                })
                            })
                        })
                    })
                })
            } else {
                setLocationOptions([]);
                setDepartmentOptions([]);
                setSeniorityLevelOptions([]);
                setEmploymentTypeOptions([]);
                setJobTitleOptions([]);
            }
        } catch (error) {
            console.error(error);
            setIsLoading(false);
        }
    };

    const parseRuleDisp = (ruledisp) => {
        if (!ruledisp) return {};
        const parts = ruledisp.split('\\').map(p => p.trim());
        const result = {};
        parts.forEach(part => {
            const [label, ...rest] = part.split(':');
            const value = rest.join(':').trim();
            if (!label) return;
            const key = label.trim().toLowerCase();
            if (key.startsWith('company')) result.companyDesc = value;
            else if (key.startsWith('location')) result.locationDesc = value;
            else if (key.startsWith('department')) result.departmentDesc = value;
            else if (key.startsWith('seniority')) result.hcodeDesc = value;
            else if (key.startsWith('job title')) result.jobTitleDesc = value;
            else if (key.startsWith('employment')) result.emplContextDesc = value;
            else if (key.startsWith('status')) result.activeStatusDesc = value;
        });
        return result;
    };
 
    useEffect(() => {
        if (props.employee?.employeeID) {
            getEmplAuthRules(props.employee.employeeID).then((savedRules) => {
                const formatted = (savedRules || []).map(r => ({
                    guid: r.ui,
                    ...parseRuleDisp(r.ruledisp),
                    isSaved: true,
                }));
                setRules(formatted);
            });
        }
    }, [props.employee?.employeeID]);
    //#endregion

    //#region Listeners
    const onSubmitTRN = async (data) => {
        let rulesData = []
        rules.forEach(rule => {
            rulesData.push(rule);
        });

        const allEmployeeIDs = includedEmployeesSectionList
            .flatMap(group => group.data)
            .map(employee => employee.employeeID)
            .filter(id => id !== undefined && id !== null);

        let dataForInsert = [];
        let promises = [];
        let insertSucc = true;

        allEmployeeIDs.forEach(employeeID => {
            dataForInsert.push({
                participants: employeeID,
                isAccepted: false,
                dateAwarded: "",
                isFacilitator: false,
                firstEvaluation: false,
                secondEvaluation: false,
                cost: "",
                rowguid: generateUniqueID(),
                trnUI: selectedTraining
            });
        });

        promises.push(deleteAllParticipants())

        if (dataForInsert.length > 0) {
            promises.push(
                saveParticipantsData(dataForInsert)
                    .then(res => {
                        if (!res) insertSucc = false;
                        else removeFromChangesAfterSave(dataForInsert);
                    })
                    .catch(() => { insertSucc = false; })
            );
        }

        try {
            await Promise.all(promises);
            showMessage({
                message: t('common:allOperationsSuccMess'),
                type: "success",
                duration: 3000,
            });
            AfterImport();
        } catch (error) {
            showMessage({
                message: t('common:issueMessage'),
                type: "danger",
                duration: 3000,
            });
        }
    };

    const onAddRule = () => {
        setValue('company', null);
        setLocationOptions([]);
        setDepartmentOptions([]);
        setSeniorityLevelOptions([]);
        setEmploymentTypeOptions([]);
        setJobTitleOptions([]);
        fetchEmployees();
        createRule();
    }

    const onAddSpecificEmployee = () => {
        if (!company) {
            if (isTrnParticipants) {
                setErrorMessage(t('common:missingFieldsSubMessage'))
            } else {
                Swal.fire({
                    title: t('common:missingFields'),
                    text: t('common:missingFieldsSubMessage'),
                    icon: "warning",
                    showCancelButton: false,
                    confirmButtonText: `<text style="font-family:'Roboto-Medium', font-size:16px">OK</text>`,
                    confirmButtonColor: '#A0A2FF',
                }).then((result) => {
                    if (result.isConfirmed) {
                        return;
                    }
                });
            }
        } else {
            setErrorMessage('');
            setShowSpecificEmployeesTab(true);
            fetchEmployees(true);
        }
    }

    const onAddDone = () => {
        if (!isTrnParticipants) {
            Swal.fire({
                title: t('common:emplsSucc'),
                icon: "success",
                showCancelButton: false,
                confirmButtonText: `<text style="font-family:'Roboto-Medium', font-size:16px">OK</text>`,
                confirmButtonColor: '#A0A2FF',
            }).then((result) => {
                if (result.isConfirmed) {
                    setSpecEmplsFinal([...specEmplsFinal, ...specEmplsAdded]);
                    setShowSpecificEmployeesTab(false);
                    setValue('company', null);
                    setLocationOptions([]);
                    setDepartmentOptions([]);
                    setSeniorityLevelOptions([]);
                    setEmploymentTypeOptions([]);
                    setJobTitleOptions([]);
                    let copySectionList = [...includedEmployeesSectionList];
                    let updatedSectionList = [];
                    includedEmployeesSectionListTemp.forEach(section => {
                        section?.data?.forEach(newPerson => {
                            updatedSectionList = addPersonToGroupedData(copySectionList, newPerson);
                        });

                    });
                    setIncludedEmployeesSectionList([...updatedSectionList]);
                    setSpecEmplsAdded([]);
                    return;
                }
            });
        } else {
            setSpecEmplsFinal([...specEmplsFinal, ...specEmplsAdded]);
            setShowSpecificEmployeesTab(false);
            setValue('company', null);
            setLocationOptions([]);
            setDepartmentOptions([]);
            setSeniorityLevelOptions([]);
            setEmploymentTypeOptions([]);
            setJobTitleOptions([]);
            let copySectionList = [...includedEmployeesSectionList];
            let updatedSectionList = [];
            includedEmployeesSectionListTemp.forEach(section => {
                section?.data?.forEach(newPerson => {
                    updatedSectionList = addPersonToGroupedData(copySectionList, newPerson);
                });

            });
            setIncludedEmployeesSectionList([...updatedSectionList]);
            setSpecEmplsAdded([]);
            return;
        }
    }

    const addPersonToGroupedData = (sectionedData, newPerson) => {
        const firstLetter = newPerson.name[0].toUpperCase();
        const sectionIndex = sectionedData.findIndex(section => section.title === firstLetter);
        if (sectionIndex !== -1) {
            // Section exists, check if the person already exists
            const personIndex = sectionedData[sectionIndex].data.findIndex(person => person.name === newPerson.name);
            if (personIndex !== -1) {
                // Person exists, remove them
                sectionedData[sectionIndex].data.splice(personIndex, 1);
                // Check if the section is now empty
                if (sectionedData[sectionIndex].data.length === 0) {
                    // Remove the empty section
                    sectionedData.splice(sectionIndex, 1);
                }
            } else {
                // Person does not exist, add them
                sectionedData[sectionIndex].data.push(newPerson);
            }
        } else {
            // Section does not exist, create a new section
            sectionedData.push({
                title: firstLetter,
                data: [newPerson]
            });
        }
        // Sort the sectioned data by title
        sectionedData.sort((a, b) => a.title.localeCompare(b.title));
        return sectionedData;
    };


    const onAddCancel = () => {
        if (!isTrnParticipants) {
            Swal.fire({
                title: t('common:onAddSpecificCancelTitle'),
                text: t('common:onAddSpecificCancelMessage'),
                icon: "warning",
                showCancelButton: true,
                confirmButtonText: 'OK',
                cancelButtonText: 'Cancel',
                confirmButtonColor: '#A0A2FF',
            }).then((result) => {
                if (result.isConfirmed) {
                    setSpecEmplsAdded([]);
                    setShowSpecificEmployeesTab(false);
                    setValue('company', null);
                    setLocationOptions([]);
                    setDepartmentOptions([]);
                    setSeniorityLevelOptions([]);
                    setEmploymentTypeOptions([]);
                    setJobTitleOptions([]);
                    return;
                }
            });
        } else {
            setSpecEmplsAdded([]);
            setShowSpecificEmployeesTab(false);
            setValue('company', null);
            setLocationOptions([]);
            setDepartmentOptions([]);
            setSeniorityLevelOptions([]);
            setEmploymentTypeOptions([]);
            setJobTitleOptions([]);
            return;
        }
    }

    const createRule = () => {
        let companyRef = company;
        let locationRef = location;
        let departmentRef = dept;
        let hcodeRef = hcode;
        let jobTitleRef = jobTitle;
        let emplContextRef = employmentContext;

        let companyDesc = '';
        let locationDesc = '';
        let departmentDesc = '';
        let hcodeDesc = '';
        let jobTitleDesc = '';
        let emplContextDesc = '';
        let activeStatusDesc = '';
        let rule = {};
        let label;

        // company 
        if (!companyRef) return;
        label = getLabelByValue(companies, companyRef);
        label = label ? label : '';
        companyDesc += `${label}`;

        // location
        if (!locationRef) locationDesc = `N/A`;
        else {
            let label = getLabelByValue(locationOptions, locationRef);
            label = label ? label : '';
            locationDesc += `${label}`;
        }

        // department
        if (!departmentRef) departmentDesc = `N/A`;
        else {
            let label = getLabelByValue(departmentOptions, departmentRef);
            label = label ? label : '';
            departmentDesc += `${label}`;
        }

        // hcode
        if (!hcodeRef) hcodeDesc = `N/A`;
        else {
            let label = getLabelByValue(seniorityLevelOptions, hcodeRef);
            label = label ? label : '';
            hcodeDesc += `${label}`;
        }

        //jobtitle
        if (!jobTitleRef) jobTitleDesc = `N/A`;
        else {
            let label = getLabelByValue(jobTitleOptions, jobTitleRef);
            label = label ? label : '';
            jobTitleDesc += `${label}`;
        }

        //emplcontext
        if (!emplContextRef) emplContextDesc = `N/A`;
        else {
            let label = getLabelByValue(employmentTypeOptions, emplContextRef);
            label = label ? label : '';
            emplContextDesc += `${label}`;
        }

        // activestatus
        label = includeInactive ? 'All' : 'Active'
        activeStatusDesc += `${label}`;

        rule = {
            companyDesc: companyDesc,
            locationDesc: locationDesc,
            departmentDesc: departmentDesc,
            hcodeDesc: hcodeDesc,
            jobTitleDesc: jobTitleDesc,
            emplContextDesc: emplContextDesc,
            activeStatusDesc: activeStatusDesc,
            company: companyRef,
            location: locationRef,
            department: departmentRef,
            seniorityLevel: hcodeRef,
            jobTitle: jobTitleRef,
            employmentContext: emplContextRef,
            includeInactive: includeInactive,
            guid: uuidv4(),
        }
        setRules((prev) => [rule, ...prev]);
    }

    const getLabelByValue = (array, value) => {
        if (array.length <= 0) return '';
        const foundObject = array.find(item => item.value === value);
        return foundObject ? foundObject.label : '';
    };

    //#endregion

    const renderTabs = useCallback(() => {
        return (
            <TabComponent
                height={height}
                colors={colors}
                styles={styles}
                loadingEmployees={loadingEmployees}
                employees={employees}
                control={control}
                employeesOriginal={employeesOriginal}
                noDataFound={noDataFound}
                showSpecificEmployeesTab={showSpecificEmployeesTab}
                setIncludedEmployeesSectionList={setIncludedEmployeesSectionListTemp}
                includedEmployeesSectionList={includedEmployeesSectionListTemp}
                includedEmplsSectionList={includedEmployeesSectionList}
                addPersonToGroupedData={addPersonToGroupedData}
                getValues={getValues}
                setValues={setValue}
                t={t}
            />
        )
    }, [loadingEmployees, employees, showSpecificEmployeesTab]);

    //#region Loading
    if (isCompaniesLoading) {
        return (
            <SafeAreaView
                style={{ justifyContent: 'center' }}>
                <ActivityIndicator animating={true} size='large' color="#86BC25" />
            </SafeAreaView>
        )
    }
    //#endregion

    return (
        <SafeAreaView style={styles.mainView} >
            <ScrollView>
                <SafeAreaView style={styles.row}>
                    <SafeAreaView style={[common.cardstyle, styles.columnLeft]}>
                        <SafeAreaView style={[styles.buttons]}>
                            {!showSpecificEmployeesTab ?
                                <>
                                    <CustomButton
                                        text={t('common:addSpecificEmpls')}
                                        onPress={() => { onAddSpecificEmployee() }}
                                        show="BUTTON_ADD"
                                        type="BUTTON_ADD"
                                    />
                                    <CustomButton
                                        text={t('common:addRule')}
                                        onPress={() => onAddRule()}
                                        show="BUTTON_ADD"
                                        type="BUTTON_ADD"
                                    />
                                    <View style={styles.verticalLine} />
                                    <CustomButton
                                        text={isTrnParticipants ? t('common:import') : t('common:save')}
                                        onPress={isTrnParticipants ? handleSubmit(onSubmitTRN) : handleSubmit(onSubmit)}
                                        show="BUTTON_SAVE"
                                        type="BUTTON_SAVE"
                                        isGradient={true}
                                    />
                                </> :
                                <View style={styles.row}>
                                    <CustomButton
                                        text={t('common:addChosenEmpls')}
                                        onPress={() => { onAddDone() }}
                                        show="BUTTON_ADD"
                                        type="BUTTON_ADD"
                                    />
                                    <CustomButton
                                        text={t('common:cancel')}
                                        onPress={() => { onAddCancel() }}
                                        type="BUTTON_CANCEL"
                                        textTop='0'
                                        sz={15}
                                    />
                                </View>
                            }
                        </SafeAreaView>
                        <SafeAreaView style={[styles.dropdowns]}>
                            <SafeAreaView style={[styles.row]}>
                                <CustomLabel
                                    value={`${t("common:company")}`}
                                    type='COMPANY'
                                />
                                <CustomControlledDropdown
                                    control={control}
                                    name={'company'}
                                    type="EDIT_EMPLOYEE"
                                    options={companies}
                                    setValue={setValue}
                                    disabled={false}
                                />
                            </SafeAreaView>
                            <SafeAreaView style={[styles.row]}>
                                <CustomLabel
                                    value={`${t("common:location")}`}
                                    type='COMPANY'
                                />
                                {isLoading ? <CustomLabel
                                    value={t('common:loading')}
                                    type='EDIT_EMPLOYEE_LOADING'
                                /> :
                                    <CustomControlledDropdown
                                        control={control}
                                        name={'location'}
                                        type="EDIT_EMPLOYEE"
                                        options={locationOptions}
                                        setValue={setValue}
                                        disabled={false}
                                    />
                                }
                            </SafeAreaView>
                            <SafeAreaView style={[styles.row]}>
                                <CustomLabel
                                    value={`${t("common:department")}`}
                                    type='COMPANY'
                                />
                                {isLoading ? <CustomLabel
                                    value={t('common:loading')}
                                    type='EDIT_EMPLOYEE_LOADING'
                                /> :
                                    <CustomControlledDropdown
                                        control={control}
                                        name={'dept'}
                                        type="EDIT_EMPLOYEE"
                                        options={departmentOptions}
                                        setValue={setValue}
                                        disabled={false}
                                    />
                                }
                            </SafeAreaView>
                            <SafeAreaView style={[styles.row]}>
                                <CustomLabel
                                    value={`${t("common:seniorityLevel")}`}
                                    type='COMPANY'
                                />
                                {isLoading ? <CustomLabel
                                    value={t('common:loading')}
                                    type='EDIT_EMPLOYEE_LOADING'
                                /> :
                                    <CustomControlledDropdown
                                        control={control}
                                        name={'hcode'}
                                        type="EDIT_EMPLOYEE"
                                        options={seniorityLevelOptions}
                                        setValue={setValue}
                                        disabled={false}
                                    />
                                }
                            </SafeAreaView>
                            <SafeAreaView style={[styles.row]}>
                                <CustomLabel
                                    value={`${t("common:jobTitle")}`}
                                    type='COMPANY'
                                />
                                {isLoading ? <CustomLabel
                                    value={t('common:loading')}
                                    type='EDIT_EMPLOYEE_LOADING'
                                /> :
                                    <CustomControlledDropdown
                                        control={control}
                                        name={'jobTitle'}
                                        type="EDIT_EMPLOYEE"
                                        options={jobTitleOptions}
                                        setValue={setValue}
                                        disabled={false}
                                    />
                                }
                            </SafeAreaView>
                            <SafeAreaView style={[styles.row]}>
                                <CustomLabel
                                    value={`${t("common:employmentContext")}`}
                                    type='COMPANY'
                                />
                                {isLoading ? <CustomLabel
                                    value={t('common:loading')}
                                    type='EDIT_EMPLOYEE_LOADING'
                                /> :
                                    <CustomControlledDropdown
                                        control={control}
                                        name={'employmentContext'}
                                        type="EDIT_EMPLOYEE"
                                        options={employmentTypeOptions}
                                        setValue={setValue}
                                        disabled={false}
                                    />
                                }
                            </SafeAreaView>
                            <SafeAreaView style={[styles.row]}>
                                <CustomLabel
                                    value={`${t("common:includeInactive")}`}
                                    type='COMPANY'
                                />
                                <CustomControlledCheckbox
                                    control={control}
                                    name={'includeInactive'}
                                    type="EDIT_EMPLOYEE"
                                />
                            </SafeAreaView>
                        </SafeAreaView>
                    </SafeAreaView>
                    <SafeAreaView style={[common.cardstyle, styles.column]}>
                        {/* search */}
                        <CustomInput
                            value={searchQuery || ""}
                            editable={true}
                            setValue={setSearchQuery}
                            type='SELECT_EMPLOYEE'
                            placeholder={`${t('common:search')} for Employees...`}
                        />
                        <SafeAreaView style={[styles.cardView]}>
                            {renderTabs()}
                        </SafeAreaView>
                    </SafeAreaView>
                </SafeAreaView>
                <SafeAreaView>
                    {rules.length > 0 &&
                        <>
                            <FlatList
                                data={rules}
                                renderItem={({ item, index }) => (
                                    <SafeAreaView>
                                        <Card
                                            style={[styles.cardStyleFunctions]} >
                                            <Card.Content>
                                                <SafeAreaView style={{ flexDirection: 'row' }}>
                                                    <View
                                                        style={[styles.item, { justifyContent: 'flex-start' }]}>
                                                        <CustomLabel
                                                            value={item.companyDesc ?? 'N/A'}
                                                            type='SUBTITLE'
                                                        />
                                                    </View>
                                                    <View
                                                        style={[styles.item, { justifyContent: 'flex-start' }]}>
                                                        <CustomLabel
                                                            value={item.locationDesc ?? 'N/A'}
                                                            type='SUBTITLE'
                                                        />
                                                    </View>
                                                    <View
                                                        style={[styles.item, { justifyContent: 'flex-start' }]}>
                                                        <CustomLabel
                                                            value={item.departmentDesc ?? 'N/A'}
                                                            type='SUBTITLE'
                                                        />
                                                    </View>
                                                    <View
                                                        style={[styles.item, { justifyContent: 'flex-start' }]}>
                                                        <CustomLabel
                                                            value={item.hcodeDesc ?? 'N/A'}
                                                            type='SUBTITLE'
                                                        />
                                                    </View>
                                                    <View
                                                        style={[styles.item, { justifyContent: 'flex-start' }]}>
                                                        <CustomLabel
                                                            value={item.jobTitleDesc ?? 'N/A'}
                                                            type='SUBTITLE'
                                                        />
                                                    </View>
                                                    <View
                                                        style={[styles.item, { justifyContent: 'flex-start' }]}>
                                                        <CustomLabel
                                                            value={item.emplContextDesc ?? 'N/A'}
                                                            type='SUBTITLE'
                                                        />
                                                    </View>
                                                    <View
                                                        style={[styles.item, { justifyContent: 'flex-start' }]}>
                                                        <CustomLabel
                                                            value={item.activeStatusDesc ?? 'N/A'}
                                                            type='SUBTITLE'
                                                        />
                                                    </View>
                                                    <View
                                                        style={[styles.item, { justifyContent: 'flex-start' }]}>
                                                        <CustomButton
                                                            iconName='trash-outline'
                                                            onPress={() => {
                                                                if (item.isSaved) {
                                                                    deleteEmplAuthRule(item.guid, props.employee.employeeID).then((res) => {
                                                                        if (res?.status === 200) {
                                                                            setRules(prevRules => prevRules.filter(rule => rule.guid !== item.guid));
                                                                        } else {
                                                                            showMessage({
                                                                                message: t('common:issueMessage'),
                                                                                type: "error",
                                                                                duration: 3000,
                                                                            });
                                                                        }
                                                                    });
                                                                } else {
                                                                    setRules(prevRules => prevRules.filter(rule => rule.guid !== item.guid));
                                                                }
                                                            }}
                                                            show='EMPL_AUTH_TRASH'
                                                            type='EMPL_AUTH_TRASH'
                                                            textTop='2'
                                                            sz={30} />
                                                    </View>
                                                </SafeAreaView>
                                            </Card.Content>
                                        </Card>
                                    </SafeAreaView>
                                )}
                                ListHeaderComponent={
                                    <SafeAreaView>
                                        <View style={[styles.row,]}>
                                            <CustomLabel
                                                value={t('common:company')}
                                                type='SUBTITLE' />

                                            <CustomLabel
                                                value={t('common:location')}
                                                type='SUBTITLE' />
                                            <CustomLabel
                                                value={t('common:department')}
                                                type='SUBTITLE' />
                                            <CustomLabel
                                                value={t('common:seniorityLevel')}
                                                type='SUBTITLE' />
                                            <CustomLabel
                                                value={t('common:jobTitle')}
                                                type='SUBTITLE' />
                                            <CustomLabel
                                                value={t('common:employmentContext')}
                                                type='SUBTITLE' />
                                            <CustomLabel
                                                value={t('common:activeStatus')}
                                                type='SUBTITLE' />
                                            <CustomLabel
                                                value={t('common:remove')}
                                                type='SUBTITLE' />
                                        </View>
                                    </SafeAreaView>
                                }
                                keyExtractor={item => item.id}
                            />
                        </>
                    }
                </SafeAreaView>
            </ScrollView >
        </SafeAreaView >


    )
};

//#region Styles
const makeStyles = (colors, width) => StyleSheet.create({
    container: {
        flex: 1,
        alignItems: 'center',
        justifyContent: 'center',
    },
    image: {
        flex: 1,
        alignItems: 'center'
    },
    mainView: {
        flex: 1,
        height: '100%'
    },
    dropdowns: {
        flex: 1,
    },
    row: {
        flex: 1,
        flexDirection: "row",
        alignItems: 'center',
        margin: 5,
    },
    buttons: {
        flexDirection: 'row',
        justifyContent: 'space-evenly',
        alignItems: 'center',
        flex: 1,
        margin: 15,
    },
    cardstyle: {
        padding: 10,
        width: "100%",
        borderRadius: 35,
        backgroundColor: colors.background_card,
        elevation: 0,
        shadowColor: 'transparent',
        shadowOffset: { width: 0, height: 0 },
        shadowOpacity: 0,
        shadowRadius: 0,
    },
    error: {
        color: colors.validation_error,
        alignSelf: 'center',
        fontSize: 14,
    },
    verticalLine: {
        backgroundColor: colors.buttons_primary,
        height: '100%',
        width: 1,
    },
    selectedItem: {
        borderWidth: 4,
        borderColor: colors.buttons_primary,
        elevation: 5,
        shadowColor: colors.card_line,
        shadowOffset: { width: 0, height: 0 },
        shadowOpacity: 0.3,
        shadowRadius: 5,
        // width: '70%',
        // flex: 1
    },
    selectedItemRemove: {
        borderWidth: 4,
        borderColor: colors.background_rejected,
        elevation: 5,
        shadowColor: colors.card_line,
        shadowOffset: { width: 0, height: 0 },
        shadowOpacity: 0.3,
        shadowRadius: 5,
        // width: '70%',
        // flex: 1
    },
    employeeContainer: {
        flex: 1,
        flexDirection: 'row',
        alignItems: 'center',
        // justifyContent: 'center',
        marginVertical: 3,
    },
    columnLeft: {
        flex: 2,
        marginHorizontal: 5,
    },
    column: {
        flex: 3,
    },
    cardView: {
        flex: 1,
        margin: '2%',
        borderRadius: 5,
        elevation: 5,
        shadowColor: colors.card_line,
        shadowOffset: { width: 0, height: 0 },
        shadowOpacity: 0.3,
        shadowRadius: 5,
        backgroundColor: colors.background_card,
        height: '80%',
        flex: 1
    },
    cardEmployees: {
        // flex: 1,
        marginTop: "1%",
        marginLeft: "2%",
        marginRight: "2%",
    },
    employeePhotograph: {
        width: 30,
        height: 30,
        marginLeft: 10,
        borderRadius: 100,
        borderWidth: 1,
        verticalAlign: 'middle',
    },
    cardStyleFunctions: {
        margin: 10,
        borderRadius: 5,
        elevation: 5,
        shadowColor: colors.card_line,
        shadowOffset: { width: 0, height: 0 },
        shadowOpacity: 0.3,
        shadowRadius: 5,
        backgroundColor: colors.background_card,
    },
    item: {
        flex: 1,
    },
    loader: {
        flex: 1,
        alignItems: 'center',
        justifyContent: 'center',
        // marginTop: '50%'
    },
});


//#endregion

export default HRAdminAuthorizationForm;